var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e/icon/arrows/left_line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29292 12.7071C7.9024 12.3166 7.9024 11.6834 8.29292 11.2929L13.9498 5.63604C14.3403 5.24551 14.9735 5.24551 15.364 5.63604C15.7545 6.02656 15.7545 6.65973 15.364 7.05025L10.4142 12L15.364 16.9497C15.7545 17.3403 15.7545 17.9734 15.364 18.364C14.9735 18.7545 14.3403 18.7545 13.9498 18.364L8.29292 12.7071Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftLine);
export default __webpack_public_path__ + "static/media/left_line.92a819011cd82787f924963cc9ec496f.svg";
export { ForwardRef as ReactComponent };